module.exports = __webpack_public_path__ + "src/images/products/allAmerican/73_Oil Cloth Bomber.png";